import type { ReactNode } from 'react';
import { PublicNavbar } from './PublicNavbar';
import { PublicFooter } from './PublicFooter';
import { PublicMotionProvider } from './PublicMotionProvider';

interface PublicLayoutProps {
  children: ReactNode;
  forceFullReloadLinks?: boolean;
}

export function PublicLayout({ children, forceFullReloadLinks = false }: PublicLayoutProps) {
  return (
    <PublicMotionProvider>
      <div className="public-site min-h-screen flex flex-col">
        <PublicNavbar forceFullReloadLinks={forceFullReloadLinks} />
        <main className="flex-1">{children}</main>
        <PublicFooter />
      </div>
    </PublicMotionProvider>
  );
}
